"use strict";
//# sourceMappingURL=script.js.map
window.onRecaptchaLoad = function () {
    let recaptcha = document.querySelectorAll('.g-recaptcha');

    recaptcha.forEach((v, k) => {
        const gid = grecaptcha.render(v, {
            'sitekey': '6LeYFLQrAAAAAJlbbeIKKmqvVk0oqK26e2wTS332',
            'theme': 'dark'
        });
        v.setAttribute('gid', gid);
    })
}

let recaptchaLoaded = false;

const loadRecaptcha = () => {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.type = 'text/javascript';
    recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
    $('head').append(recaptchaScript);
}

const contactForm = document.querySelectorAll('.section-contact');

contactForm.forEach(v => {
    let observer = new IntersectionObserver((e) => {
        if (e[0].intersectionRatio > 0) {
            if (!recaptchaLoaded) {
                observer.unobserve(v)
                loadRecaptcha()
                recaptchaLoaded = true
            }
        }
    }, {
        threshold: 0.2
    });
    observer.observe(v);
})


//QUIZ
// next prev
let divs = $('.show-section section');
let totalScore = 0;
let selectedAnswers = [];
let totalSteps = divs.length;

let now = 0; // currently shown div
divs.hide().first().show(); // hide all divs except first

//show active step
function showActiveStep(currentStep) {
    let $stepSingle = $(".step-single");
    if ($(`#step${currentStep + 1}`).is(':visible')) {
        $stepSingle.removeClass("show")
        $stepSingle.eq(currentStep).addClass('active show');
    }
}

function next() {
    // $("html, body").animate({scrollTop: 600}, "fast");
    divs.eq(now).hide();
    now = (now + 1 < divs.length) ? now + 1 : 0;
    divs.eq(now).show(); // show next
    showActiveStep(now);
}

$(".prev").on('click', function () {
    $('.radio-field').addClass('bounce-left');
    $('.radio-field').removeClass('bounce-right');
    $(".step-single.show").removeClass("active")
    divs.eq(now).hide();
    now = (now > 0) ? now - 1 : divs.length - 1;
    divs.eq(now).show(); // show previous
    showActiveStep(now);
})

setTimeout(function () {
    $('.step-single').eq(0).addClass('active show');
}, 800)


// quiz validation
function radioValidate(stepnumber) {
    let checkradio = $("#step" + stepnumber + " input").map(function () {
        return !!$(this).is(':checked');
    }).get();

    return checkradio.some(Boolean);
}

// form validation
$(document).ready(function () {
    $('.steps button.next').on('click', function () {
        let currentStep = () => $(this).attr('data-step');
        let isCurrentLastStep = () => $(this).attr('data-last-step');
        let isCurrentStepValid = radioValidate(currentStep());

        if (!isCurrentStepValid) {
            (function (el) {
                setTimeout(function () {
                    el.children().remove('.reveal');
                }, 3000);
            }($('#error' + currentStep()).append('<div class="reveal alert alert-danger"><span>!</span>Wybierz odpowiedź!</div>')));
        } else {
            const $radioField = $('#step' + currentStep() + ' .radio-field');
            if (isCurrentLastStep() === "1") {
                countResult();
                showResult();
                $("#sub").html('Zakończono');
            } else {
                $radioField.removeClass('bounce-left');
                $radioField.addClass('bounce-right');
                setTimeout(function () {
                    next();
                }, 900)
            }
        }
    })

    //close btn
    $("#close-btn").on('click', function () {
        $('.result_page').removeClass('result_page_show');
        location.reload();
        setTimeout(function () {
            $('.loadingresult').css('display', 'none');
        }, 1000)
    })
})
function ensurePartnerCookie () {

    let ref = localStorage.getItem('partner_ref');

    if (!ref) {
        ref = new URLSearchParams(window.location.search).get('partner_ref');
        if (ref) localStorage.setItem('partner_ref', ref);
    }

    console.log('[ensurePartnerCookie] ref:', ref);

    if (!ref) return;

    const hidden = document.querySelector('#quiz_result_form input[name="client_cookie"]');
    if (hidden) {
        hidden.value = ref;
        console.log('[ensurePartnerCookie] hidden.value set:', hidden.value);
    } else {
        console.warn('[ensurePartnerCookie] hidden input NOT found');
    }
}
document.addEventListener('DOMContentLoaded', ensurePartnerCookie);
function showResult() {
    $('.loadingresult').css('display', 'grid');
    ensurePartnerCookie();

    gtag('event', 'event_complete_audit_form', {
        'event_category': 'Quiz Interaction',
        'event_label': 'Completed audit quiz',
        'value': 1
    });

    for (let i = 0; i < quizResultsData.length; i++) {
        if (totalScore >= quizResultsData[i].from_points && totalScore <= quizResultsData[i].to_points) {
            $('.result_page h2.quiz_result_header').html(quizResultsData[i].header);
            $('.result_page span.quiz_result_description').html(quizResultsData[i].description);

            const $answerList = $('.result_page ol.quiz_result_description_ol_list');
            $answerList.empty();

            selectedAnswers.map(answer => {
                if (answer.answer_result.length > 0) {
                    $answerList.append(`<li class="answer-list-item">${answer.answer_result}</li>`);
                }
            });
        }
    }

    let canMakeContactFormAjax = true;

    document.querySelector('#quiz_result_form').addEventListener('submit', (async function (e) {
        e.preventDefault();
        ensurePartnerCookie();

        const loaderContent = '<div class="loader loader--style2" title="1"> <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"> <path fill="#fff" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/> </path> </svg> </div>';

        let data = new URLSearchParams(new FormData(this)).toString();

        const $form = this;

        let dataForm = new URLSearchParams({
            action: 'send_quiz_form',
            formData: data,
            quizAnswers: JSON.stringify(selectedAnswers),
        });

        document.querySelector('#quiz_result_form #sendForm').innerHTML = loaderContent;
        canMakeContactFormAjax = false;
        $form.querySelector('.form-response').textContent = '';

        fetch('/wp-admin/admin-ajax.php', {
            method: 'post',
            body: dataForm,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    $form.querySelector('.form-control').value = '';
                    document.location.href = '/thank-you-page';
                    gtag('event', 'event_submit_audit_form', {
                        'event_category': 'Form Interaction',
                        'event_label': 'Audit Form submit',
                        'value': 1
                    });
                } else {
                    $form.querySelector('.form-response').textContent = data.data.message;
                    canMakeContactFormAjax = true;
                    $form.querySelector('#sendForm').innerHTML = buttonContentContact;
                }
            });
    }));

    setTimeout(function () {
        $('.result_page').addClass('result_page_show');
    }, 500)
}

function countResult() {
    totalScore = 0;
    selectedAnswers = [];

    for (let i = 1; i < totalSteps + 1; i++) {
        $(`#step${i} .radio-field input:checked`).each(function () {
            totalScore += parseInt($(this).val());
            selectedAnswers.push({
                question: $(this).data('question_title'),
                answer: $(this).data('answer_title'),
                answer_result: $(this).data('answer_result')
            });
        })
    }
}

// Uncheck radio input if another radio input is checked in same step
for (let i = 1; i < totalSteps + 1; i++) {
    $(`#step${i} .radio-field input`).on('click', function () {
        $(`#step${i} .radio-field input`).not(this).prop('checked', false);
    });
}

const homeModal = document.querySelector('.home-modal');

if (homeModal) {
    setTimeout(function () {
        if (localStorage.getItem('homeModal') !== 'true') {
            homeModal.classList.add('home-modal_d-block');
        }
    }, 10000);

    const closeBtn = document.querySelector('.home-modal .home-modal-top__close'),
        btn = document.querySelector('.home-modal .home-modal-inner__button .btn');

    closeBtn.addEventListener('click', function (e) {
        e.preventDefault();

        homeModal.classList.remove('home-modal_d-block');
        localStorage.setItem('homeModal', 'true');
    });

    btn.addEventListener('click', function (e) {
        e.preventDefault();

        localStorage.setItem('homeModal', 'true');
        window.location.href = btn.getAttribute('href');
    });
}
const swiper = new Swiper(".mySwiper", {
    spaceBetween: 40,
    slidesPerView: 1,
    breakpoints: {
        1260: {
            slidesPerView: 3
        },
        970: {
            slidesPerView: 2
        }
    },
    navigation: {},
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const projectSolutionsItems = document.querySelectorAll('.project-solutions__item');
    let currentIndex = 0;
    let autoSwitch;

    function resetProgressBar(item) {
        const progressBar = item.querySelector('.progress-indicator');

        projectSolutionsItems.forEach(i => {
            const bar = i.querySelector('.progress-indicator');
            bar.style.transition = 'none';
            bar.style.height = '0';
        });

        setTimeout(() => {
            progressBar.style.transition = 'height 6s linear';
            progressBar.style.height = '100%';
        }, 50);
    }

    function switchToNextItem() {
        projectSolutionsItems.forEach(item => {
            item.classList.remove('active');
            const body = item.querySelector('.solutions-content__body');
            if (body) {
                body.classList.remove('active');
            }
        });

        currentIndex = (currentIndex + 1) % projectSolutionsItems.length;
        const nextItem = projectSolutionsItems[currentIndex];

        nextItem.classList.add('active');
        const nextBody = nextItem.querySelector('.solutions-content__body');
        if (nextBody) {
            nextBody.classList.add('active');
        }
        resetProgressBar(nextItem);

        const image = nextItem.getAttribute('data-item-image');
        const mainImage = document.querySelector('#main-image');
        mainImage.src = image;
    }

    projectSolutionsItems[0].classList.add('active');
    const firstBody = projectSolutionsItems[0].querySelector('.solutions-content__body');
    if (firstBody) {
        firstBody.classList.add('active');
    }
    resetProgressBar(projectSolutionsItems[0]);

    autoSwitch = setInterval(switchToNextItem, 6000);

    projectSolutionsItems.forEach((item, index) => {
        item.addEventListener('click', function () {
            clearInterval(autoSwitch);

            projectSolutionsItems.forEach(i => {
                i.classList.remove('active');
                const body = i.querySelector('.solutions-content__body');
                if (body) {
                    body.classList.remove('active');
                }
                i.querySelector('.progress-indicator').style.height = '0';
            });

            this.classList.add('active');
            const body = this.querySelector('.solutions-content__body');
            if (body) {
                body.classList.add('active');
            }

            const image = this.getAttribute('data-item-image');
            const mainImage = document.querySelector('#main-image');
            mainImage.src = image;

            currentIndex = index;
            resetProgressBar(this);

            autoSwitch = setInterval(switchToNextItem, 6000);
        });
    });
});


document.querySelectorAll('ul.nav > li > i').forEach(item => {
    item.addEventListener('click', function (event) {
        const liElements = document.querySelectorAll('ul.nav > li');
        const currentLi = this.parentElement;
        const isAlreadyShowed = currentLi.classList.contains('showed');

        liElements.forEach(li => {
            li.classList.remove('showed');
        });

        if (!isAlreadyShowed) {
            currentLi.classList.add('showed');
        }
    });
});

function getPartnerRefFromUrl () {
    return new URLSearchParams(window.location.search).get('partner_ref');
}

function getReferralInfo () {
    if (!document.referrer) return null;
    try {
        const u = new URL(document.referrer);
        return { full: document.referrer, domain: u.hostname, source: u.hostname };
    } catch {
        return null;
    }
}

function setLS (key, value) {
    try { localStorage.setItem(key, value); } catch (err) { console.error(err); }
}

function stripQueryParams () {
    const clean = window.location.origin + window.location.pathname;
    if (location.href !== clean) history.replaceState(null, '', clean);
}


(function () {
    const partnerRef = getPartnerRefFromUrl();
    if (!partnerRef) return;

    setLS('partner_ref', partnerRef);
    const refInfo = getReferralInfo();
    if (refInfo) {
        setLS('ref_full',   refInfo.full);
        setLS('ref_domain', refInfo.domain);
        setLS('ref_source', refInfo.source);
    }

    const payload = new URLSearchParams({
        action:     'icp_add_clients_log',
        partner_id: partnerRef,
        source:     refInfo ? refInfo.domain : 'brak',
    });

    fetch('/wp-admin/admin-ajax.php', {
        method:      'POST',
        credentials: 'same-origin',
        headers:     { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:        payload.toString()
    })
        .then(r => r.json())
        .then(ans => console.log('[clients_log] OK:', ans))
        .catch(err => console.error('[clients_log] error:', err));

    stripQueryParams();

})();